import { AnalyticsScreenNameEnum } from "../../enums/AnalyticsEnums";
import InventorySubType from "../../enums/InventorySubType";

export function getAnalyticsScreenType(inventorySubType: InventorySubType): AnalyticsScreenNameEnum {
  switch (inventorySubType) {
    case InventorySubType.WEB_DASHBOARD:
      return AnalyticsScreenNameEnum.DASHBOARD;
    case InventorySubType.WEB_PROFILE_FORM:
      return AnalyticsScreenNameEnum.PROFILE;
    case InventorySubType.REGISTRATION:
      return AnalyticsScreenNameEnum.REGISTRATION;
    case InventorySubType.MOBILE_DASHBOARD:
      return AnalyticsScreenNameEnum.DASHBOARD;
  }
}
